import {
  WaveContainer,
  StaticWaveContainer,
  FullImageWrapper,
  FullImageContentWrapper,
  SquareImageWrapper,
  SquareImageContentWrapper,
  DefaultWrapper,
  Description,
  MobileWrapper,
  HeaderWrap,
  DesktopWrapper,
  DefaultHeaderCont,
} from './Header.styles'
import WaveDivider from '../WaveDivider'
import Container from '../Container'
import { Spacing, Heading } from '@big-red-group/storefront-common-ui'

type HeaderProps = {
  image?: string
  href: string
  title: string
  description?: string
  variant?: 'square' | 'full' | 'default'
}

// TODO: Square image header tablet view, larger wave banner

function SquareImageHeader({ image, title, description, href }: HeaderProps) {
  return (
    <>
      <MobileWrapper data-testid="square-image-header">
        <DefaultHeader title={title} description={description} href={href} />
        <Spacing size="M" />
      </MobileWrapper>
      <DesktopWrapper data-testid="square-image-header">
        <WaveContainer largeCurve type="squareImageHeader">
          <WaveDivider fill="#FFFFFF" curveSize="large" style={{ height: '50%' }} />
        </WaveContainer>
        <Container spacing="XL" noSpacingBottom>
          <SquareImageWrapper noImage={!image}>
            <SquareImageContentWrapper>
              <Heading size="XXL" as="h1" balanced spacing={false}>
                <span dangerouslySetInnerHTML={{ __html: title }}></span>
              </Heading>
              <Spacing size="M" />
              <Description>{description}</Description>
              <Spacing size="M" />
            </SquareImageContentWrapper>
            {/* @ts-ignore fetchpriority */}
            {image && <img alt="hero-image" src={image} width={525} height={525} fetchpriority="high" />}
          </SquareImageWrapper>
          <Spacing size="XL" />
        </Container>
      </DesktopWrapper>
    </>
  )
}

function FullImageHeader({ image, title, description, href }: HeaderProps) {
  return (
    <>
      <MobileWrapper data-testid="full-image-header">
        <DefaultHeader title={title} description={description} href={href} />
        <Spacing size="XXXL" />
      </MobileWrapper>
      <DesktopWrapper data-testid="full-image-header">
        <WaveContainer largeCurve type="fullImageHeader">
          <WaveDivider fill="#FFFFFF" curveSize="large" style={{ height: '50%' }} />
        </WaveContainer>
        <Container spacing="XL" noSpacingBottom>
          {image && (
            <>
              <FullImageWrapper image={image}>
                <FullImageContentWrapper>
                  <Heading size="XXL" as="h1" balanced spacing={false}>
                    <span dangerouslySetInnerHTML={{ __html: title }}></span>
                  </Heading>
                  <Spacing size="M" />
                  <Description>{description}</Description>
                </FullImageContentWrapper>
              </FullImageWrapper>
            </>
          )}
          <Spacing size="XXXL" />
        </Container>
      </DesktopWrapper>
    </>
  )
}
// Using as the mobile header for all headers
function DefaultHeader({ title, description, href }: HeaderProps) {
  return (
    <DefaultHeaderCont>
      <Container spacing="XL" noSpacingBottom>
        <HeaderWrap data-testid="default-header">
          <DefaultWrapper>
            <Heading size="XXL" as="h1" balanced spacing={false}>
              <span dangerouslySetInnerHTML={{ __html: title }}></span>
            </Heading>
            {description && <Spacing size="M" />}
            <Description>{description}</Description>
            <Spacing size="M" />
          </DefaultWrapper>
        </HeaderWrap>
      </Container>

      <StaticWaveContainer>
        <WaveDivider fill="#FFFFFF" curveSize="medium" style={{ height: '100%' }} />
      </StaticWaveContainer>
    </DefaultHeaderCont>
  )
}

function Header({ image, href, title, description, variant = 'default' }: HeaderProps) {
  return (
    <>
      {variant === 'square' && <SquareImageHeader image={image} title={title} description={description} href={href} />}
      {variant === 'full' && <FullImageHeader image={image} title={title} description={description} href={href} />}
      {variant === 'default' && <DefaultHeader image={image} title={title} description={description} href={href} />}
    </>
  )
}

export default Header
